import { useMemo } from 'react';
import { PlannerMapDataElement } from 'components/common/types/Planner.types';

const NEARBY_RADIUS_DEGREES = 0.001;

interface NearbyMarker {
  lat: number;
  lng: number;
  tooltip: string;
}

export const useNearbyAssetsMarkers = (
  centre: { lat: number; lng: number } | null,
  clusterAssetsData: PlannerMapDataElement[] | undefined,
): NearbyMarker[] | undefined => {
  return useMemo(() => {
    if (!centre || !clusterAssetsData?.length) return undefined;

    const nearbyAssets = clusterAssetsData.filter(
      (asset) =>
        Math.abs(asset.properties.latitude - centre.lat) <= NEARBY_RADIUS_DEGREES &&
        Math.abs(asset.properties.longitude - centre.lng) <= NEARBY_RADIUS_DEGREES,
    );

    const groupedByPosition = new Map<string, { lat: number; lng: number; frameIds: string[] }>();

    nearbyAssets.forEach(({ properties: { latitude: lat, longitude: lng }, name }) => {
      const key = `${lat},${lng}`;
      const existing = groupedByPosition.get(key);

      if (existing) {
        if (name) existing.frameIds.push(name);
      } else {
        groupedByPosition.set(key, {
          lat,
          lng,
          frameIds: name ? [name] : [],
        });
      }
    });

    return Array.from(groupedByPosition.values()).map(({ lat, lng, frameIds }) => ({
      lat,
      lng,
      tooltip: frameIds.join('\n'),
    }));
  }, [centre, clusterAssetsData]);
};
